import {AggregationControl, TimeControl, ConditionsControl} from '@octavius-rocks/ui'
import PageviewsChart from "../PageviewsChart";
import {useFilterAttributes} from "../../hook/useConfig";
import {useUiDashboardQuery} from "../../hook/useUi";
import QueryDashboardButton, {QueryDashboardResetButton} from "../widgets/QueryDashboardButton";
import TopPostsWidget from "../TopPostsWidget";
import TopRefererWidget from "../TopRefererWidget";
import {useTranslation} from "../../hook/useTranslation";
import ScreenSizesWidget from "../ScreenSizesWidget";
import {DEFAULT_DASHBOARD_QUERY_ARGS} from "../../data/defaults";
import {useStyles} from "./Analytics.styles";
import {QueryControl} from "../../../../../../../../OCTAVIUS-UI-COMPONENTS/src";

const Analytics = () => {

    const styles = useStyles()
    const i18n = useTranslation("dashboard")

    const [args, setArgs] = useUiDashboardQuery(DEFAULT_DASHBOARD_QUERY_ARGS) // ui state control of form

    const {
        aggregation,
        from,
        to,
        conditions
    } = args;

    const filterAttributes = useFilterAttributes();

    return <div className={styles.root}>
        <QueryControl
            className={styles.queryControl}
            value={{
                aggregation,
                time: {start:from,end:to},
                conditions,
            }}
            onChange={(value)=>{
                setArgs({
                    ...args,
                    from: value.time.start,
                    to: value.time.end,
                    aggregation: value.aggregation,
                    conditions: value.conditions,
                })
            }}
        />

        <div className={styles.buttons}>
            <QueryDashboardButton/>
            <QueryDashboardResetButton/>
        </div>

        <div className={styles.chart}>
            <PageviewsChart height={400}/>
        </div>

        <div className={styles.topLists}>
            <div>
                <h1>{i18n.top_posts}</h1>
                <TopPostsWidget/>
            </div>
            <div>
                <h1>{i18n.top_referer}</h1>
                <TopRefererWidget/>
            </div>
            <div>
                <h1>{i18n.screen_sizes}</h1>
                <ScreenSizesWidget/>
            </div>
        </div>
    </div>
};

export default Analytics;
